import { useState } from "react";
import { useSSRHook } from "ssr-hook";
import { useRouter } from "easy-page-router";
import { Footer, Header } from "../../Layout";
import { useHead } from "../../services/common";
import { Loading, Page, ReloadLine, ShareButton } from "../../components";
import { useLang } from "../../services/lang";
import { useHandleError } from "../../services/api";
import { useUser } from "../../components/User";
import Dialog from "../../components/Dialog";

import { TeamSelect, getTeamUrl } from "./components/TeamSelect";
import { TeamDetail } from "./components/TeamDetail";
import { EditTeam } from "./components/EditTeam";

import { ID, Team, TeamPreview } from "../../../types";

export default function TeamPage({ teamId }: { teamId: ID }) {
    const { push } = useRouter();
    const { lang, dict } = useLang();
    const { userId, isLoggedIn, showUserDialog } = useUser();

    const [team, error, isLoading, reload] = useSSRHook<Team>(`/api/team?teamId=${encodeURIComponent(teamId)}`);
    useHandleError(error);

    const title = dict.seo.team.getTitle(team?.title);
    const description = dict.seo.team.getDescription(team?.description);

    useHead({
        title,
        description,
    });

    const [editTeam, setEditTeam] = useState<null | TeamPreview>(null);

    function handleEditTeam(team: TeamPreview) {
        if (!isLoggedIn)
            showUserDialog();

        setEditTeam(team);
    }

    async function reloadTeam(id?: string) {
        setEditTeam(null);
        reload();

        if (id && id !== teamId)
            push(getTeamUrl(lang, id));
    }

    return <Page theme={team?.theme} fixed={<>
        <Header title={dict.team} link={`/${dict.urlTeam}`}>
            <ShareButton title={title} description={description} />
        </Header>
        <Footer />
        <ReloadLine value={team} error={error} isLoading={isLoading} onReload={reload} />
    </>}>
        <div className={`full-page team`}>

            {isLoading && <Loading />}
            {error && <p className="error">{dict.teamError}</p>}
            {team && <>
                <TeamSelect team={team} onTeamEdit={handleEditTeam} />
                <TeamDetail {...team} userHashId={userId} onChange={reloadTeam} onTeamEdit={() => handleEditTeam(team)} />
            </>}

            {/* Edit team */}
            {isLoggedIn && <Dialog show={!!editTeam} onClose={() => setEditTeam(null)}>
                {editTeam && <EditTeam {...editTeam} onSuccess={reloadTeam} />}
            </Dialog>}
        </div>
    </Page>;
}
export { getTeamUrl };